class ProductETA {
  constructor(variants, sku, ip) {
    this.variants = variants;
    this.sku = sku;
    this.available = ip === "continue";
    this.quantity = 1;
    // this.buttonTextStart = "Check ETA";
    this.buttonTextStart = "Next estimated arrival date: ";
    this.buttonTextAvailable = "Next estimated arrival date: ";
    this.buttonTextUnknown = "Call 1300 296 505 for availability";
    this.predecessorSelector = ".add-to-cart-sec";
    this.variantSelector = ".variant-input-wrap input";
    this.quantitySelector = "input[name='quantity']";
    this.variantSelectors = $(document).find(this.variantSelector);
    this.quantityField = $(document).find(this.quantitySelector)[0];
    this.stockInStore = document.getElementById("cnc-container");
    this.productQtyForm = document.querySelector(".product__quantity_block");
    // the parent div container class that is unique
    this.qtyButton = this.productQtyForm.querySelectorAll(".js-qty__adjust");
    this.getQuantity();
    this.addETAButton();
    this.addEventHandlers();
    this.displayETAButton();
  }
  getQuantity() {
    this.quantityField !== undefined ? (this.quantity = this.quantityField.value) : (this.quantity = 1);
  }
  addETAButton() {
    var predecessor = document.querySelector(this.predecessorSelector);

    this.etaButton = document.createElement("button");
    this.etaButton.id = "rex-eta";
    this.etaButton.type = "button";
    // this.etaButton.classList = "btn btn--full";
    // this.etaButton.style.marginTop = "10px";
    predecessor.after(this.etaButton);

    // new pre-order styles:
    this.etaButton.style.backgroundColor = "#fadede";
    this.etaButton.style.marginTop = "12px";
    this.etaButton.style.padding = "4px";
    this.etaButton.style.width = "100%";
    this.etaButton.style.cursor = "default";
    this.etaButton.style.textAlign = "left";

    this.etaButtonText = document.createElement("div");
    // this.etaButtonText.textContent = "PRE ORDER";
    this.etaButtonText.textContent = "BACK ORDER";
    this.etaButton.appendChild(this.etaButtonText);

    this.etaButtonText = document.createElement("span");
    this.etaButtonText.textContent = this.buttonTextStart;
    this.etaButton.appendChild(this.etaButtonText);

    this.etaSpinner = document.createElement("div");
    this.etaSpinner.id = "spinner";
    this.etaSpinner1 = document.createElement("div");
    this.etaSpinner1.classList.add("bounce1");
    this.etaSpinner.appendChild(this.etaSpinner1);
    this.etaSpinner2 = document.createElement("div");
    this.etaSpinner2.classList.add("bounce2");
    this.etaSpinner.appendChild(this.etaSpinner2);
    this.etaSpinner3 = document.createElement("div");
    this.etaSpinner3.classList.add("bounce3");
    this.etaSpinner.appendChild(this.etaSpinner3);
    this.etaButton.after(this.etaSpinner);
    this.getProductETA();
  }
  addEventHandlers() {
    // this.etaButton.addEventListener("click", (event) => {
    //   this.getProductETA();
    // });

    for (let i = 0; i < this.variantSelectors.length; i++) {
      this.variantSelectors[i].addEventListener("change", (event) => {
        setTimeout(() => {
          this.currentVariant = this.variants.find((variant) => variant.id == this.findGetParameter("variant"));
          this.sku = this.currentVariant.sku;
          this.available = this.currentVariant.inventory_policy === "continue";
          this.getProductETA();
          // this.displayETAButton();
        }, 250);
      });
    }

    for (let i = 0; i < this.qtyButton.length; i++) {
      this.qtyButton[i].addEventListener("click", (event) => {
        this.getQuantity();
        this.getProductETA();
      });
    }
    if (this.quantityField !== undefined) {
      this.quantityField.addEventListener("input", (event) => {
        this.getQuantity();
        this.getProductETA();
        //this.displayETAButton();
      });

      this.quantityField.addEventListener("change", (event) => {
        this.getQuantity();
        this.getProductETA();
        // this.displayETAButton();
      });
    }
  }
  displayETAButton() {
    if (this.available) {
      // this.etaButtonText.textContent = this.buttonTextStart;
      this.etaButton.style.display = "block";
      if (this.stockInStore !== undefined) {
        this.stockInStore.style.display = "none";
      }
    } else {
      this.etaButton.style.display = "none";
      if (this.stockInStore !== undefined) {
        this.stockInStore.style.display = "block";
      }
    }
  }
  getProductETA() {
    var parent = this;

    // parent.etaButton.style.display = "none";
    // parent.etaSpinner.style.display = "block";

    var url = `/apps/retailexpress/products/eta?sku=${this.sku}&quantity_ordered=${this.quantity}&available_for_preorder=true`;

    var etaRequest = new Request(url);

    // DEV: new code to display the ETA btn
    this.getQuantity();
    this.displayETAButton();

    fetch(etaRequest)
      .then((response) => response.json())
      .then((data) => {
        if (data.data.length > 0) {
          var eta = new Date(data.data[0].eta);
          // Reset the Time on today for comparison
          var today = new Date().setHours(0, 0, 0, 0);
          //Reset the Time on eta for comparison
          eta.setHours(0);
          eta.setMinutes(0);
          eta.setSeconds(0);
          eta.setMilliseconds(0);
          if (eta <= today) {
            parent.etaButtonText.textContent = parent.buttonTextUnknown;
          } else {
            const yyyy = eta.getFullYear();
            let mm = eta.getMonth() + 1; // Months start at 0!
            let dd = eta.getDate();

            if (dd < 10) dd = "0" + dd;
            if (mm < 10) mm = "0" + mm;

            const formattedDate = dd + "/" + mm + "/" + yyyy;
            parent.etaButtonText.textContent = parent.buttonTextAvailable + formattedDate;
            //new Intl.DateTimeFormat("en-AU").format(eta);
          }
        } else {
          parent.etaButtonText.textContent = parent.buttonTextUnknown;
        }
      })
      .catch((error) => {
        console.error("ETA fetch failed:", error);
        parent.etaButtonText.textContent = parent.buttonTextUnknown;
      });
  }
  findGetParameter(parameterName) {
    var result = null,
      tmp = [];
    location.search
      .substr(1)
      .split("&")
      .forEach(function (item) {
        tmp = item.split("=");
        if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
      });
    return result;
  }
}
